module.exports = __webpack_public_path__ + "static/annotations-macbook-d4a434e9c8a2fa7e4c9f798fbd1c3b35.png";